export default __webpack_public_path__ + "static/media/cristian.b7a09c28.jpg";